import React from "react";
import { Button } from "semantic-ui-react";
interface Props {
  item: server.dto.DocumentChecklistItem
  onApproved: () => void
  onDeclined: () => void
}

const ChecklistNotAnsweredApproveOrDeclineRowCard = (props: Props) => {
  const [savingApprove, setSavingApprove] = React.useState(false);

  const onApprove = () => {
    if (savingApprove) return;
    setSavingApprove(true);
    props.onApproved();
  };

  const { item } = props;
  return <div>
    <div className="grow1">
      <div>
        <h3>{item.question}</h3>
      </div>
    </div>

    <div>
      <Button
        loading={savingApprove}
        className="green"
        icon={<i className="icon-check small" style={{ fontSize: 11, lineHeight: "10px" }} />}
        onClick={onApprove}
        title={RESX.Buttons.Approve}
      />
    </div>
    <div>
      <Button
        className="red"
        onClick={props.onDeclined}
        icon={<i className="icon-x small" />}
        title={RESX.Buttons.Decline}
      />
    </div>
  </div>;
};

export default ChecklistNotAnsweredApproveOrDeclineRowCard;